const CaliforniaNotice = () => {
    return (
        <div className="flex flex-col gap-4 pt-6" id="california-notice">
            <h3 className="font-sans font-bold text-lg leading-7 text-base-content">For California residents:</h3>
            <p className="text-base-content font-medium text-sm leading-5 font-sans">
                If you are 65 years of age or older, pursuant to California Insurance Code §789.8(b), we are required to advise
                you of the following. If you plan on the sale or liquidation of any stock, bond, IRA, certificate of deposit,
                mutual fund, annuity, or other asset to fund the purchase of this product, please be advised that you may be
                subject to some or all of the following as a result of the sale or liquidation: Adverse tax consequences; early
                withdrawal penalties; or other costs and/or penalties. You or your agent may also wish to consult independent
                legal or financial advice before selling or liquidating any assets and prior to the purchase of any life or
                annuity products being solicited, offered for sale, or sold.
            </p>
            <p className="text-base-content font-medium text-sm leading-5 font-sans">
                This policy contains a modified benefit clause, which means if you suffer a covered accidental death, you get
                the full amount of your coverage. But if you suffer a non-accidental death within the first two years of
                coverage, your beneficiaries get 100% of the premiums paid, plus an extra 30%. After two years, the full Benefit
                Amount is paid for death due to any cause.
            </p>
        </div>
    );
};

export default CaliforniaNotice;
